import { render, staticRenderFns } from "./testOrder.vue?vue&type=template&id=2b8378c3&"
import script from "./testOrder.vue?vue&type=script&lang=js&"
export * from "./testOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports